/* eslint-disable react/prop-types, react/jsx-props-no-spreading */
import React from 'react';
import noop from 'lodash/noop';

import { Block, ErrorMessage } from '@atoms';
import { ChapterField, SlugField, TextField, LocaleSelect } from '@molecules';
import RichTextField from '@molecules/RichTextField';
import { NO_MARGIN_BOTTOM } from '@constants';
import ROUTES from '@constants/routes';

import Form from '../Form';

import RulesField from './RulesField';
import { FORM_FIELD } from './constants';

const SectionForm = ({ initialValues = {}, error, form, sectionId, locale, onSaveDraft, onPublish }) => {
  const initialParentChapter = initialValues[FORM_FIELD.PARENT_CHAPTER.name];

  return (
    <Form form={form} hideRequiredMark layout="vertical" wrapperCol={{ span: 24 }} initialValues={initialValues}>
      <ErrorMessage error={error} variant="block" spaced />
      <Block spaced>
        <ChapterField
          {...FORM_FIELD.PARENT_CHAPTER}
          initialParentItem={initialParentChapter}
          style={NO_MARGIN_BOTTOM}
        />
      </Block>
      <Block spaced>
        <LocaleSelect
          locale={locale}
          disabled={!sectionId}
          route={`${ROUTES.SECTIONS}/:id/:locale`}
          needsSave={form.isFieldsTouched}
          onSaveDraft={onSaveDraft}
          onPublish={onPublish}
        />
        <TextField {...FORM_FIELD.TITLE} />
        <SlugField
          {...FORM_FIELD.SLUG}
          generateSlugFrom={!initialValues[FORM_FIELD.SLUG.name] && FORM_FIELD.TITLE.name}
        />
        <RichTextField {...FORM_FIELD.TEXT} />
        <TextField multiline {...FORM_FIELD.SEO_DESCRIPTION} style={NO_MARGIN_BOTTOM} />
      </Block>

      {/* Stupid hack to make antd form properly update form */}
      <Form.List noStyle name={FORM_FIELD.RULES.name}>
        {noop}
      </Form.List>
      {sectionId && (
        <Block spaced>
          <RulesField locale={locale} name={FORM_FIELD.RULES.name} parentSectionId={sectionId} />
        </Block>
      )}
    </Form>
  );
};

SectionForm.useForm = () => Form.useForm(FORM_FIELD);

export default SectionForm;
